import { Card } from "primereact/card";
import { QuestionResponse } from "../models";
import { Checkbox } from "primereact/checkbox";
export default function StateWideDataInfoComponent({ response, dataSource, downLoadProviderDataByDataSource }:
    {
        response: QuestionResponse[], dataSource: string, downLoadProviderDataByDataSource: (dataSource: string) => void

    }) {


    const downloadDataSource = () => {
        downLoadProviderDataByDataSource(dataSource);
    }

    const hasValidThreshold = () => {
        if(response.every(r => r.hasValidThreshold)) return true;
        else if(response.some(r => r.hasValidThreshold === null)) return null; 
        return false;
    }

    const renderData = () => {
        {
            let hasValidThresholdValue = hasValidThreshold();
            //to handle null value because !null => true
            if(hasValidThresholdValue !== null) {
                hasValidThresholdValue = !hasValidThresholdValue;
            }
            
            return (
                <Card>
                    <div style={{ margin: '10px' }}>
                        <div className="p-field-checkbox" style={{ margin: '10px' }}>
                            <Checkbox inputId="yes" checked={hasValidThreshold() ?? false} disabled />
                            <label htmlFor="yes"> Yes</label>
                        </div>
                        <div className="p-field-checkbox" style={{ margin: '10px' }}>
                            <Checkbox inputId="no" checked={hasValidThresholdValue ?? false} disabled />
                            <label htmlFor="no"> No</label>
                        </div>
                    </div>

                    {response.length > 0 && response.map((item, index) => (
                        <div className="grid">
                            {item.fieldName && <div key={index} className="row" style={{ margin: '10px' }}>
                                <span className='p-bold'>{item.fieldName} </span>:  <span>{item.fieldValue ?? 'N/A'}</span>
                            </div>
                            }
                        </div>

                    ))}

                    <div style={{ marginTop: '20px' }}>
                        <a onClick={downloadDataSource} style={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }}>{dataSource.toUpperCase()} Extract</a>
                    </div>

                </Card >)
        }
        return (
            <>N/A</>
        )
    }
    return (
        <>{renderData()}</>
    )
}